import {
  LiveStatusEnum,
  ChapterTypeEnum,
  ResourceTypeEnum,
  PlayBackTypeEnum,
  EnableEnum,
} from '/@/enums/statusEnum';

export interface RecentlyLearnedVO {
  /**
   * 课程名称
   */
  courseName?: string;
  /**
   * 时长，单位：s
   */
  duration?: number;
  /**
   * 直播状态 0:未开始 1：直播中 2：已结束
   */
  liveStatus?: LiveStatusEnum;
  /**
   * 内容id（直播id 或 视频id）
   */
  resourceId?: string;
  /**
   * 内容类型 0:视频 1：直播 2：回放
   */
  resourceType?: ResourceTypeEnum;
  /**
   * 房间号
   */
  roomId?: string;
  /**
   * 标题
   */
  title?: string;
  /**
   * 视频定位 秒
   */
  videoLocation?: number;
}

export const enum ResourcePlatformType {
  /**
   * 百家云
   */
  BJY = 0,
  /**
   * 灵狮
   */
  LINKS = 1,
}

/**
 * 内容信息
 */
export interface ResourceModel {
  /**
   * 助教id列表
   */
  assistantIdList?: string[];
  /**
   * 助教老师列表
   */
  assistantNameList?: string[];
  /**
   * 直播房间id
   */
  roomId?: string;
  /**
   * 开课时间
   */
  classStartTime?: string;
  /**
   * 是否为资源
   */
  isResource?: 0 | 1;
  /**
   * 是否解锁 0:否 1:是
   */
  isUnLock?: 0 | 1;
  /**
   * 资源id
   */
  resourceId?: string;
  /**
   * 资源类型 0：录播视频 1：直播
   */
  resourceType?: ResourceTypeEnum;
  recentlyLearnedVO?: RecentlyLearnedVO;
  /**
   * 时长（秒）
   */
  duration?: string;
  /**
   * 直播状态 0:未开播 1：直播中 2：已结束
   */
  liveStatus?: LiveStatusEnum;
  /**
   * 直播时间
   */
  liveTime?: string;
  /**
   * 资源标题
   */
  title?: string;
  /**
   * 更新时间
   */
  updateTime?: string;
  /**
   * 更新人
   */
  updateUser?: string;
  /**
   * 资源排序号
   */
  sort?: number;
  /**
   * 视频id
   */
  videoId?: string;
  /**
   * 讲师id
   */
  teacherId?: string;
  /**
   * 主讲老师姓名
   */
  teacherName?: string;
  /**
   * 主讲老师昵称
   */
  teacherNick?: string;
  /**
   * 完整章节链
   */
  chapterChain?: string[];
  sessionId?: string;
  /**
   * 回放类型
   */
  playBackType: PlayBackTypeEnum;
  /**
   * 资源平台
   */
  resourcePlatform: ResourcePlatformType;
}

/**
 * 子章节信息
 */
export interface ChapterResourceModel {
  /**
   * 章节id
   */
  chapterId?: string;
  /**
   * 章节名称
   */
  chapterName?: string;
  /**
   * 章节类型 0：章 1：节
   */
  chapterType?: ChapterTypeEnum;
  /**
   * 是否是资源 0:否 1：是
   */
  isResource?: 0 | 1;
  /**
   * 父章节
   */
  parentId?: string;
  /**
   * 内容信息
   */
  resourceVOList?: ResourceModel[];
  /**
   * 排序号
   */
  sort?: number;
  /**
   * 子章节信息
   */
  children?: ChapterResourceModel[];
  /**
   * 完整章节链
   */
  chapterChain?: string[];
}

export interface CatalogueModel {
  /**
   * 章节资源信息列表
   */
  chapterResourceListVOList?: ChapterResourceModel[];
  /**
   * 课程名称
   */
  courseName?: string;
  /**
   * 课程封面图片
   */
  coverImage?: string;
  /**
   * 课程封面视频
   */
  coverVideo?: string;
  /**
   * 班期结束时间
   */
  endTime?: string;
  /**
   * 班期开始时间
   */
  startTime?: string;
  /**
   * 班期名称
   */
  termName?: string;
}

export interface CourseInviteBaseInfoVO {
  /** 课程id */
  courseId: string;
  /** 课程名称 */
  courseName: string;
  /** 是否套餐课程 0:否 1：是 */
  isCombo: EnableEnum;
  /** 售价 */
  sellPrice: string;
}

export enum InviteLinkType {
  /** 课程链接 */
  course,
  /** 班期链接 */
  schedule,
  /** 课时链接 */
  period,
}

export interface ResourceInviteBaseInfoVO {
  /** 课程呢ID */
  courseId: string;
  /**
   * 开课时间
   */
  classTime: string;
  /**
   * 课程名称
   */
  courseName: string;
  /**
   * 资源id
   */
  resourceId: string;
  /**
   * 资源类型 0:视频 1：直播 2：回放
   */
  resourceType: ResourceTypeEnum;
  /**
   * 平台类型，0-百家云 1-灵狮
   */
  resourcePlatform: ResourcePlatformType;
  /**
   * 班期ID
   */
  termId: string;
  /**
   * 班期名称
   */
  termName: string;
  /**
   * 标题
   */
  title: string;
  /**
   * 是否未小课
   */
  isSmallCourse: EnableEnum;
}

export interface TagItem {
  /**
   * 标签组id
   */
  tagGroupId: string;
  /**
   * 标签id
   */
  tagId: string;
  /**
   * 标签名称
   */
  tagName: string;
}

export interface TermInviteBaseInfoVO {
  /** 课程呢ID */
  courseId: string;
  /** 课程名称 */
  courseName: string;
  /** 是否套餐课程 0:否 1：是 */
  isCombo: EnableEnum;
  /** 是否固定班期 */
  isFixedTerm: EnableEnum;
  /** 售价 */
  sellPrice: string;
  /** 班期ID */
  termId: string;
  /** 班期名称 */
  termName: string;
}

export interface InviteInfo {
  courseInviteBaseInfoVO: CourseInviteBaseInfoVO;
  /** 是否添加标签 */
  hasTag: EnableEnum;
  id: string;
  /** 链接类型 */
  inviteLinkType: InviteLinkType;
  /** 邀请人 */
  inviteUser: string;
  /** 图片 */
  picture: string;
  /** 描述 */
  remark: string;
  resourceInviteBaseInfoVO: ResourceInviteBaseInfoVO;
  shortLink: string;
  /** 标签列表 */
  tagList: TagItem[];
  termInviteBaseInfoVO: TermInviteBaseInfoVO;
  /** 标题 */
  title: string;
}

export interface PlaybackThridParty {
  // 直播课时id
  lessonId: string;
  // 直播课时类型
  lessonType: number;
  // 灵狮视频id
  linksVideoId: string;
  // 第三方视频id
  thirdPartyId: string;
  // 视频是否删除状态 归档数据和删除数据 都算删除 0 否 1 是
  videoIsDel: number;
}
